import {KonvaComponent} from "./KonvaComponent.mjs";
import {MiniLayoutPreview} from "./MiniLayoutPreview.mjs";
import {KonvaComponentBase} from "./KonvaComponentBase.mjs";
// Globalna tablica do przechowywania obiektów KonvaComponent
const konvaComponents : KonvaComponentBase[] = [];
export let globalSupressResize:boolean = false; // globalna flaga do wymuszenia wyłączenia resize'u dla wszystkich komponentów

// Funkcja tworząca nowy obiekt KonvaComponent i zapisująca go w tablicy
// Zwraca indeks, pod którym obiekt został zapisany
export function createKonvaComponent (className: string, dotNetReference: any, domContainerUid: any, ...args: any[]) {
    let component;
    if (className === "MiniLayoutPreview") {
        component = new MiniLayoutPreview(dotNetReference, domContainerUid, ...args);
    } else {
        // @ts-ignore
        component = new KonvaComponent(dotNetReference, domContainerUid, ...args);
    }

    // @ts-ignore
    konvaComponents.push(component);
    return konvaComponents.length - 1; // zwracamy indeks ostatnio dodanego obiektu
}

// Funkcja wywołująca określoną metodę na obiekcie KonvaComponent o danym indeksie
// methodName jest nazwą metody, którą chcemy wywołać, a ...args to argumenty przekazywane do tej metody
export function callMethodOnKonvaComponent (index: number, methodName: string, args: any[]) {
    let component:KonvaComponentBase = konvaComponents[index];
    // @ts-ignore
    if (component && typeof component[methodName] === 'function') {
        // @ts-ignore
        return component[methodName](...args);
    } else {
        console.error("Nie znaleziono obiektu lub metoda " + methodName + " nie istnieje.");
    }
}
export function disposeKonvaComponent (index: number) {
    let component = konvaComponents[index];
    if (component) {
        component.dispose();
        konvaComponents[index] = null;
        if (index === konvaComponents.length - 1) {
            konvaComponents.pop(); // jeśli usuwany element jest ostatni usuwamy go z tablicy
        }
    }
}